import {Dimensions, StyleSheet} from 'react-native';
import {Colors} from '../../../../../../constants/Colors';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  containerFilter: {
    height: Dimensions.get('window').height * 0.9,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 25,
  },
  spaceHorizontal: {
    paddingHorizontal: 25,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  filterTitle: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
  },
  containerDrop: {
    marginTop: 30,
    paddingHorizontal: 25,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 45,
    marginTop: 50,
  },
  containerConfirmed: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
  },
  filterText: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  orderText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
  },
  codeText: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 19,
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 20,
    fontFamily: 'TCCC-UnityText Bold',
  },
  ProductsText: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
    fontFamily: 'TCCC-UnityText Bold',
  },
  spaceSummary: {
    paddingHorizontal: 5,
  },
  containerSummary: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  summaryText: {
    fontSize: 12,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  quantityText: {
    fontSize: 12,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.GrayPallete.lightgrayThree,
  },
  containerSubtotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  subtotalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  priceText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  containerTotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  totalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  totalPrice: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  codeTextCont: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 19,
    color: Colors.GrayPallete.lightgrayThree,

    fontFamily: 'TCCC-UnityText Bold',
  },
});
